<script>
// 表头渲染组件
export default {
  name: 'renderHeader',
  props: ["renderHeader", "column", "_index", "index"],
  render (h) {
    let { renderHeader,column, _index, index } = this
    let template = renderHeader(h, { column, $index: _index }, index)
    return (
      <div>
        {template}
      </div>
    )
  }
}
</script>

<style lang='scss' scoped>
.renderHeader {
}
</style>
